///<reference path="../../../typings/tsd.d.ts" />
///<reference path="../../bindings/commons/API/Client/api.d.ts" />

module banks {
    
    export class BanksService {
        $http: ng.IHttpService
        $q: ng.IQService
        api: API.Client.BankApi;

        /*@ngInject*/
        constructor($http: ng.IHttpService, $q: ng.IQService) {
            this.$http = $http;
            this.$q = $q;
            this.api = new API.Client.BankApi(this.$http);
        }
        
        getBanks(): ng.IPromise<API.Client.BanksResponse> {
            return this.api.banksGet().then(response => {
                return response.data.banks;
            });
        };
    }
    
    angular.module('banks', []).service('banksService', BanksService);

}
